module.exports = __webpack_public_path__ + "static/media/star-good.9d72378a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/newDropshipperApp/images/star-good.svg
// module id = 2179
// module chunks = 0